import styled from 'styled-components/native';
import getPlatformType from '../../helpers/helpers';
const layoutType = getPlatformType();

export const CardContainer = styled.View`
  flex-direction: row;
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 12px 14px;
  margin-vertical: 6px;
  border-width: 1px;
  border-color: #E5E7EB;
`;

export const FileIconWrap = styled.View`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: #F0E8FF;
  align-items: center;
  justify-content: center;
`;

export const InfoWrap = styled.View`
  flex: 1;
  margin-left: 12px;
  margin-right: 8px;
  justify-content: center;
`;

export const ActionsWrap = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const ActionBtn = styled.View`
  width: 34px;
  height: 34px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
`;

// Keep legacy exports for backward compatibility
export const Left = styled.View`
  flex: 0.7;
  justify-content: center;
  align-items: center;
`;
export const Right = styled.View`
  width: 25%;
  justify-content: center;
  align-items: center;
`;
export const Center = styled.View`
  width: 25%;
  justify-content: center;
  align-items: center;
`;
export const Row = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
